/* eslint-disable compat/compat */

/**
 * === Progress bar
 */

customElements.define(
  'progressbar-rewards',
  class ProgressBarRewards extends HTMLElement {
    constructor() {
      super();

      let selectors = {
          "progressSettings" : "[data-progressbar-rewards-settings]",
          "progressSettingsData" : "progressbarRewardsSettings",
          "progressCurrentMessage" : "[data-progressbar-rewards--current-message]",
          "progressNextMessage" : "[data-progressbar-rewards--next-message]",
          "progressImage" : "[data-progressbar-rewards--image]",
          "progressBarContainer" : "[data-progressbar-rewards--progress-bar-container]",
          "progressBar" : "[data-progressbar-rewards--progress-bar]",
          "progressThreshold" : "[data-progressbar-rewards--threshold]",
          "progressThresholdMarker" : "[data-progressbar-rewards--threshold-marker]",
      };

      this.selectors = selectors;

      this.init();
    }

    connectedCallback() {
      // Watch for the remove event, if its a gift
      window.addEventListener('productManuallyRemoved', (event) => {
        if (event.target.dataset.productId) this.handleManualItemRemoval(event.target.dataset.productId);
      });
    }

    disconnectedCallback() {
      window.removeEventListener('productManuallyRemoved', (event) => {
        // Call handleManualItemRemoval with the product ID
        if (event.target.dataset.productId) this.handleManualItemRemoval(event.target.dataset.productId);
      });
    }

    getCookieItemReward(name) {
      let v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
      return v ? v[2] : null;
    }

    setCookieItemReward(name, value, days) {
      let d = new Date;
      d.setTime(d.getTime() + 24*60*60*1000*days);
      document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
    }

    deleteCookieItemReward(name) {
      this.setCookieItemReward(name, '', -1);
    }

    // If the user manually removes a product, we need to store that in a cookie to prevent it from being added again on the next cart load
    handleManualItemRemoval(productId) {
      let manuallyRemovedRewards = [];
      if (this.getCookieItemReward('manuallyRemovedRewards') !== null) {
        manuallyRemovedRewards = JSON.parse(this.getCookieItemReward('manuallyRemovedRewards'));
      }
      manuallyRemovedRewards.push(productId);
      this.setCookieItemReward('manuallyRemovedRewards', JSON.stringify(manuallyRemovedRewards), 3);
    }

    async init() {

      const progressSettingsElement = this.querySelector(this.selectors.progressSettings);

      if(progressSettingsElement !== null && progressSettingsElement !== undefined) {

        // === Get all elements

        const packSettingsData = JSON.parse(progressSettingsElement.dataset[this.selectors.progressSettingsData]);

        // const progressCurrentMessage = this.querySelector(this.selectors.progressCurrentMessage);
        const progressNextMessage = this.querySelector(this.selectors.progressNextMessage);
        const progressImage = this.querySelector(this.selectors.progressImage);
        const progressBarContainer = this.querySelector(this.selectors.progressBarContainer);
        const progressBar = this.querySelector(this.selectors.progressBar);
        const progressThresholds = this.querySelectorAll(this.selectors.progressThreshold);
        const progressThresholdMarkers = this.querySelectorAll(this.selectors.progressThresholdMarker);

        let lastStepReach = false;

        const cart = await cartManager.getCart();
        let queue = Promise.resolve();

        // === Cart total price

        let cartTotalPrice = cart.total_price;

        // === Get steps info

        // - Get current and next step
        let currentStep = null;
        let nextStep = null;
        for (let index = 0; index < packSettingsData.steps.length; index++) {
          if (cartTotalPrice >= parseInt(packSettingsData.steps[index].threshold)) {
            currentStep = packSettingsData.steps[index];
            nextStep = packSettingsData.steps[index + 1];
          }
        }

        // - None step reach
        if (currentStep == null && nextStep == null) {
          nextStep = packSettingsData.steps[0];
        }

        // - Last step reach
        if (currentStep !== null && nextStep == null) {
          lastStepReach = true;
        }

        // === Set markers
        if (progressThresholdMarkers !== null) {
          const markerWidth = progressBarContainer.offsetWidth / progressThresholdMarkers.length;
          const markerPosition = markerWidth / 2;
          progressThresholdMarkers.forEach(function callback(marker, index) {
            marker.style.left = (markerWidth * index) + markerPosition + 'px';
          });
        }

        // === Set rewards progress bar

        let nextMessage = null;
        let nextImage = null;
        let nextThreshold = null;

        if (!lastStepReach) {
          const leftBeforeThreshold = '<span class="scz-cart-rewards__price-left">' + Shopify.formatMoney(parseInt(nextStep.threshold) - cartTotalPrice) + '</span>';
          nextMessage = nextStep.before_message.replace('##left##', leftBeforeThreshold);
          nextImage = nextStep.image;
          nextThreshold = parseInt(nextStep.threshold);
        } else {
          nextMessage = currentStep.after_message;
          nextImage = currentStep.image;
          nextThreshold = parseInt(currentStep.threshold);
        }

        progressImage.src = nextImage;
        progressNextMessage.innerHTML = nextMessage.replace("##%##", "'");

        if (lastStepReach) {
          progressBar.style.width = "100%";
          this.classList.add('is-last-step-reached');
        } else {
          this.classList.remove('is-last-step-reached');

          // - Default: Percentage from 0€
          let percentage = (parseFloat(cartTotalPrice) * 100) / nextThreshold;

          const nextMarker = this.querySelector('[data-progressbar-rewards--threshold-marker="'+ nextThreshold.toString() +'"]');

          let currentMarker = null;
          if (currentStep !== null) {
            currentMarker = this.querySelector('[data-progressbar-rewards--threshold-marker="'+ parseInt(currentStep.threshold).toString() +'"]');
          }

          if (nextMarker !== null) {
            let nextMarkerPosition = null;
            if (currentStep !== null && currentStep.threshold != 0) {
              nextMarkerPosition = parseFloat(nextMarker.style.left);
              const currentMarkerPosition = parseFloat(currentMarker.style.left);

              percentage = ((parseFloat(cartTotalPrice) - parseInt(currentStep.threshold)) * 100) / (nextThreshold - parseInt(currentStep.threshold));

              progressBar.style.width = currentMarkerPosition + (percentage * ((nextMarkerPosition - currentMarkerPosition) / 100)) + "px";
            } else {
              nextMarkerPosition = parseFloat(nextMarker.style.left);
              progressBar.style.width = percentage *  nextMarkerPosition / 100 + "px";
            }
          } else {
            progressBar.style.width = percentage + "%";
          }

        }

        if (progressThresholds !== null) {
          progressThresholds.forEach(function callback(threshold, index) {
            if (threshold.dataset["progressbarRewards-Threshold"] <= cartTotalPrice) {
              threshold.classList.add('active');
            } else {
              threshold.classList.remove('active');
            }
          });
        }

        // === Rewards products
        if (packSettingsData !== null && packSettingsData !== undefined && packSettingsData.steps && packSettingsData.steps.length > 0) {

          let items = [];
          let manuallyRemovedRewards = [];
          if (this.getCookieItemReward('manuallyRemovedRewards') !== null) {
            manuallyRemovedRewards = JSON.parse(this.getCookieItemReward('manuallyRemovedRewards'));
          }

          packSettingsData.steps.forEach( async (step) => {
            if ((step.type && step.type === 'product') || (step.type && step.type === 'product_with_choice')) {

              // - Check if step threshold reach
              if (cartTotalPrice >= parseInt(step.threshold)) {

                // - Check if product already added
                let productAlreadyAdded = false;
                for (let index = 0; index < cart.items.length; index++) {
                  if (cart.items[index].properties !== null) {
                    if (cart.items[index].properties['_is_reward'] === true ) {
                      if (step.id == cart.items[index].properties["_reward_id"]) {
                        productAlreadyAdded = true;
                      }
                    }
                  }
                }

                // - Check reward is adding
                let rewardsIsAdding = [];
                let productAlreadyIsAdding = false;
                if (this.getCookieItemReward('rewardsIsAdding') !== null) {
                  rewardsIsAdding = JSON.parse(this.getCookieItemReward('rewardsIsAdding'));
                }
                if (rewardsIsAdding.length > 0) {
                  rewardsIsAdding.forEach(rewardIsAdding => {
                    if (rewardIsAdding.id === step.id) {
                      productAlreadyIsAdding = true;
                    }
                  });
                }

                // - Check if product was manually removed
                let productWasManuallyRemoved = false;
                if (manuallyRemovedRewards.includes(step.variant_id)) productWasManuallyRemoved = true;

                // - If product not added: add product

                if (productAlreadyAdded === false && productAlreadyIsAdding === false && productWasManuallyRemoved === false) {

                  // - Add cookie is adding
                  rewardsIsAdding.push({
                    variant_id: step.variant_id,
                    threshold: step.threshold,
                    id: step.id
                  });
                  this.setCookieItemReward('rewardsIsAdding', JSON.stringify(rewardsIsAdding), 3);

                  // - Set items to add
                  if (step.type === 'product') {

                    items.push(
                      {
                        id: step.variant_id,
                        quantity: 1,
                        properties: {
                          '_is_reward': true,
                          '_reward_id': step.id,
                          '_reward_threshold': step.threshold
                        }
                      }
                    );

                  } else if (step.type === 'product_with_choice') {

                    items.push(
                      {
                        id: step.variant_id,
                        quantity: 1,
                        properties: {
                          '_is_reward': true,
                          '_is_reward_with_choice': true,
                          '_reward_id': step.id,
                          '_reward_threshold': step.threshold
                        }
                      }
                    );

                  }

                }

              }

            }
          });

          // === Add items
          if (items.length > 0) {

            queue = queue.then(async () => {

              const rewardAddedResult = await this.addItems(items);
              if (rewardAddedResult === true) {

                // - Get cookie 'rewardsAdded'
                let rewardsAdded = [];
                if (this.getCookieItemReward('rewardsAdded') !== null) {
                  rewardsAdded = JSON.parse(this.getCookieItemReward('rewardsAdded'));
                }

                // - Get cookie 'rewardsIsAdding'
                let rewardsIsAdding = [];
                if (this.getCookieItemReward('rewardsIsAdding') !== null) {
                  rewardsIsAdding = JSON.parse(this.getCookieItemReward('rewardsIsAdding'));
                }

                items.forEach(item => {

                  // - Add reward in cookie 'rewardsAdded'
                  let itemIsAlreadyInCookie = false;
                  if (rewardsAdded.length > 0) {
                    rewardsAdded.forEach(rewardAdded => {
                      if (rewardAdded.id === item.properties['_reward_id']) {
                        itemIsAlreadyInCookie = true;
                      }
                    });
                  }
                  if (itemIsAlreadyInCookie === false) {
                    rewardsAdded.push({
                      variant_id: item.id,
                      threshold: item.properties['_reward_threshold'],
                      id: item.properties['_reward_id']
                    });
                  }

                  // - Remove reward in cookie 'rewardsIsAdding'
                  if (rewardsIsAdding.length > 0) {
                    for (let index = 0; index < rewardsIsAdding.length; index++) {
                      if(rewardsIsAdding[index].id == item.properties['_reward_id']) {
                        rewardsIsAdding.splice(index, 1);
                      }
                    }
                  }

                });

                this.setCookieItemReward('rewardsAdded', JSON.stringify(rewardsAdded), 3);
                this.setCookieItemReward('rewardsIsAdding', JSON.stringify(rewardsIsAdding), 3);

              }

            });

          }

        }

        // === Remove items: If reward product added and his threshold > cartTotalPrice: remove this reward product
        if (cart.items && cart.items.length > 0) {

          let itemsToRemove = {};

          for (let index = 0; index < cart.items.length; index++) {
            if (cart.items[index].properties !== null) {
              if (cart.items[index].properties['_is_reward'] === true) {
                if (parseInt(cart.items[index].properties['_reward_threshold']) > cartTotalPrice) {

                  // - Check reward is removing
                  let rewardsIsRemoving = [];
                  let productAlreadyIsRemoving = false;
                  if (this.getCookieItemReward('rewardsIsRemoving') !== null) {
                    rewardsIsRemoving = JSON.parse(this.getCookieItemReward('rewardsIsRemoving'));
                  }
                  if (rewardsIsRemoving.length > 0) {
                    rewardsIsRemoving.forEach(rewardIsRemoving => {
                      if (rewardIsRemoving.id === cart.items[index].properties["_reward_id"]) {
                        productAlreadyIsRemoving = true;
                      }
                    });
                  }

                  if (productAlreadyIsRemoving === false) {

                    // - Add cookie is removing
                    rewardsIsRemoving.push({
                      variant_id: cart.items[index].variant_id,
                      threshold: cart.items[index].properties["_reward_threshold"],
                      id: cart.items[index].properties["_reward_id"]
                    });
                    this.setCookieItemReward('rewardsIsRemoving', JSON.stringify(rewardsIsRemoving), 3);

                    // - Set items to remove
                    itemsToRemove[cart.items[index].variant_id] = 0;

                  }

                }
              }
            }
          }

          // Remove items
          if (Object.keys(itemsToRemove).length > 0) {
            queue = queue.then(async () => {

              const rewardsRemoved = await this.removeItems(itemsToRemove);
              if (rewardsRemoved === true) {

                // - Get cookie 'rewardsAdded'
                let rewardsAdded = [];
                if (this.getCookieItemReward('rewardsAdded') !== null) {
                  rewardsAdded = JSON.parse(this.getCookieItemReward('rewardsAdded'));
                }

                // - Get cookie 'rewardsIsRemoving'
                let rewardsIsRemoving = [];
                if (this.getCookieItemReward('rewardsIsRemoving') !== null) {
                  rewardsIsRemoving = JSON.parse(this.getCookieItemReward('rewardsIsRemoving'));
                }

                for (const [key] of Object.entries(itemsToRemove)) {

                  // - Remove reward in cookie 'rewardsAdded'
                  if (rewardsAdded.length > 0) {
                    for (let index = 0; index < rewardsAdded.length; index++) {
                      if(rewardsAdded[index].variant_id == key.toString()) {
                        rewardsAdded.splice(index, 1);
                      }
                    }
                  }

                  // - Remove reward in cookie 'rewardsIsRemoving'
                  if (rewardsIsRemoving.length > 0) {
                    for (let index = 0; index < rewardsIsRemoving.length; index++) {
                      if(rewardsIsRemoving[index].variant_id == key.toString()) {
                        rewardsIsRemoving.splice(index, 1);
                      }
                    }
                  }

                }

                this.setCookieItemReward('rewardsAdded', JSON.stringify(rewardsAdded), 3);
                this.setCookieItemReward('rewardsIsRemoving', JSON.stringify(rewardsIsRemoving), 3);

              }

            });
          }

        }

        // === Queue error
        queue.catch((e) => {
          console.error(e);
        });


        // === [Security] If cartTotalPrice == 0: delete cookie 'rewardsAdded'
        if (cartTotalPrice == 0) {
          this.deleteCookieItemReward('rewardsAdded');
          this.deleteCookieItemReward('rewardsIsAdding');
          this.deleteCookieItemReward('rewardsIsRemoving');
        }

      }

    }

    async addItems(items) {

      const config = fetchConfig('javascript');
      config.headers['Content-Type'];
      const itemsData = {
        'items': items
      };
      config.body = JSON.stringify(itemsData);

      const result = await fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            return false;
          }

          return true;
        })
        .catch((e) => {
          const allLoadingOverlay = this.querySelectorAll('.loading-overlay');
          if (allLoadingOverlay.length > 0) {
            allLoadingOverlay.forEach((overlay) =>
              overlay.classList.add('hidden'),
            );
          }
          console.error(e);
        });

      return result;

    }

    async removeItems(items) {

      const config = fetchConfig('javascript');
      config.headers['Content-Type'];
      config.body = JSON.stringify({
        updates: items
      });

      const result = await fetch(`${routes.cart_update_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            return false;
          }

          return true;
        })
        .catch((e) => {
          console.error(e);
        });

      return result;

    }
  }
);

// Drawer item reward
customElements.define(
  'drawer-item-reward',
  class DrawerItemReward extends HTMLElement {
    constructor() {
      super();

      let selectors = {
          "updateRewardTriggers" : "[data-item-reward-update]"
      };

      this.selectors = selectors;

      this.updateRewardTriggers = this.querySelectorAll(this.selectors.updateRewardTriggers);

      this.init();
    }

    getCookieItemReward(name) {
      let v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
      return v ? v[2] : null;
    }

    setCookieItemReward(name, value, days) {
      let d = new Date;
      d.setTime(d.getTime() + 24*60*60*1000*days);
      document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
    }

    init() {
      const self = this;

      if (this.updateRewardTriggers.length > 0) {
        this.updateRewardTriggers.forEach(trigger => {
          trigger.addEventListener('click', async (e) => {
            e.preventDefault();

            trigger.classList.add('loading');

            const cart = await cartManager.getCart();

            if (cart.items.length > 0) {

              // === Add selected reward and Remove current reward

              // - Get current and this rewards variant id
              const currentRewardVariantId = trigger.getAttribute('data-current-reward-variant-id');
              const thisRewardVariantId = trigger.getAttribute('data-this-reward-variant-id');

              if (currentRewardVariantId !== null && currentRewardVariantId !== undefined && thisRewardVariantId !== null && thisRewardVariantId !== undefined) {

                // - Get reward properties
                let properties = null;
                for (let index = 0; index < cart.items.length; index++) {
                  if (cart.items[index].variant_id == currentRewardVariantId && cart.items[index].properties) {
                    properties = cart.items[index].properties;
                  }
                }

                if (properties !== null) {

                  // - Get cookie 'rewardsAdded'
                  let rewardsAdded = [];
                  if (self.getCookieItemReward('rewardsAdded') !== null) {
                    rewardsAdded = JSON.parse(this.getCookieItemReward('rewardsAdded'));
                  }
                  // - Replace reward in cookie 'rewardsAdded'
                  if (rewardsAdded.length > 0) {
                    for (let index = 0; index < rewardsAdded.length; index++) {
                      if(rewardsAdded[index].id == properties["_reward_id"]) {
                        rewardsAdded.splice(index, 1);
                      }
                    }
                  }
                  rewardsAdded.push({
                    variant_id: thisRewardVariantId,
                    threshold: properties["_reward_threshold"],
                    id: properties["_reward_id"]
                  });
                  self.setCookieItemReward('rewardsAdded', JSON.stringify(rewardsAdded), 3);

                  // - Get cookie 'rewardsIsRemoving'
                  let rewardsIsRemoving = [];
                  if (self.getCookieItemReward('rewardsIsRemoving') !== null) {
                    rewardsIsRemoving = JSON.parse(self.getCookieItemReward('rewardsIsRemoving'));
                  }
                  // - Add cookie is removing
                  rewardsIsRemoving.push({
                    variant_id: currentRewardVariantId,
                    threshold: properties["_reward_threshold"],
                    id: properties["_reward_id"]
                  });
                  self.setCookieItemReward('rewardsIsRemoving', JSON.stringify(rewardsIsRemoving), 3);

                  // - Get cookie 'rewardsIsAdding'
                  let rewardsIsAdding = [];
                  if (self.getCookieItemReward('rewardsIsAdding') !== null) {
                    rewardsIsAdding = JSON.parse(self.getCookieItemReward('rewardsIsAdding'));
                  }
                  // - Add cookie is adding
                  rewardsIsAdding.push({
                    variant_id: thisRewardVariantId,
                    threshold: properties["_reward_threshold"],
                    id: properties["_reward_id"]
                  });
                  self.setCookieItemReward('rewardsIsAdding', JSON.stringify(rewardsIsAdding), 3);

                  // - Remove current reward

                  let itemsToRemove = {};
                  itemsToRemove[currentRewardVariantId] = 0;

                  const removeResult = await self.removeItems(itemsToRemove);
                  if (removeResult === true) {

                    // - Add selected reward

                    let itemsToAdd = [];
                    itemsToAdd.push(
                      {
                        id: thisRewardVariantId,
                        quantity: 1,
                        properties: properties
                      }
                    );

                    const addResult = await self.addItems(itemsToAdd);
                    if (addResult === true) {

                      // - Remove reward in cookie 'rewardsIsRemoving'
                      if (rewardsIsRemoving.length > 0) {
                        for (let index = 0; index < rewardsIsRemoving.length; index++) {
                          if(rewardsIsRemoving[index].id == properties["_reward_id"]) {
                            rewardsIsRemoving.splice(index, 1);
                          }
                        }
                      }
                      self.setCookieItemReward('rewardsIsRemoving', JSON.stringify(rewardsIsRemoving), 3);

                      // - Remove reward in cookie 'rewardsIsAdding'
                      if (rewardsIsAdding.length > 0) {
                        for (let index = 0; index < rewardsIsAdding.length; index++) {
                          if(rewardsIsAdding[index].id == properties["_reward_id"]) {
                            rewardsIsAdding.splice(index, 1);
                          }
                        }
                      }
                      self.setCookieItemReward('rewardsIsAdding', JSON.stringify(rewardsIsAdding), 3);

                    }

                  }

                }


              }

            }

          });
        });
      }

    }

    async addItems(items) {

      const config = fetchConfig('javascript');
      config.headers['Content-Type'];
      const itemsData = {
        'items': items
      };
      config.body = JSON.stringify(itemsData);

      const result = await fetch(`${routes.cart_add_url}?drawer-item-reward`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            return false;
          }

          return true;
        })
        .catch((e) => {
          const allLoadingOverlay = this.querySelectorAll('.loading-overlay');
          if (allLoadingOverlay.length > 0) {
            allLoadingOverlay.forEach((overlay) =>
              overlay.classList.add('hidden'),
            );
          }
          console.error(e);
        });

      return result;

    }

    async removeItems(items) {

      const config = fetchConfig('javascript');
      config.headers['Content-Type'];
      config.body = JSON.stringify({
        updates: items
      });

      const result = await fetch(`${routes.cart_update_url}?drawer-item-reward`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            return false;
          }

          return true;
        })
        .catch((e) => {
          console.error(e);
        });

      return result;

    }

  }
);
